import ComponentBoxContent from 'src/model/component-box'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import ButtonOptionsModal from '../components/custom-plugins/actions/button-options-modal'
import axios from 'axios'
import URL from 'src/api/url'
import { removeDropAreaNarrow } from '../components/custom-plugins/simple-box/utils'
import Instruction from '../components/instruction'
import { AI_INSTRUCTION } from 'src/reducers/course/type'
import AiLoading from '../components/ai-loading'
import { snackbarShowAction } from 'src/reducers/snackbar/action'
import {
  processStartAction,
  processStartEnd,
} from 'src/reducers/process/action'

import SnackbarMessage from 'src/model/snackbar'

export const getYouTubeEmbedUrl = url => {
  const patterns = {
    shortLink: /youtu\.be\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
    watchLink: /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)(?:&(.*))?/,
    embedLink: /youtube\.com\/embed\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
    shareLink: /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
    liveLink: /youtube\.com\/live\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
  }

  const lowerUrl = url.replace(/^(https?:\/\/)?(www\.)?/i, '').toLowerCase()
  const originalUrl = url

  for (let type in patterns) {
    const match = lowerUrl.match(patterns[type])
    if (match && match[1]) {
      const originalMatch = originalUrl.match(new RegExp(patterns[type].source))
      const videoId = originalMatch[1]
      const params = match[2] || ''

      return `https://www.youtube.com/embed/${videoId}${
        params ? '?' + params : ''
      }`
    }
  }

  return null
}

export const getVimeoEmbedUrl = url => {
  const patterns = {
    standardLink: /vimeo\.com\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    channelLink: /vimeo\.com\/channels\/[^/]+\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    groupLink: /vimeo\.com\/groups\/[^/]+\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    albumLink: /vimeo\.com\/album\/[^/]+\/video\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    showcaseLink: /vimeo\.com\/showcase\/[^/]+\/video\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    eventLink: /vimeo\.com\/event\/[^/]+\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    embedLink: /player\.vimeo\.com\/video\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
  }

  const lowerUrl = url.replace(/^(https?:\/\/)?(www\.)?/i, '').toLowerCase()
  const originalUrl = url

  for (let type in patterns) {
    const match = lowerUrl.match(patterns[type])
    if (match && match[1]) {
      const originalMatch = originalUrl.match(new RegExp(patterns[type].source))
      const videoId = originalMatch[1]
      const hash = match[2] || ''

      return `https://player.vimeo.com/video/${videoId}?h=${hash}`
    }
  }

  return null
}

export const checkIfInsideSimpleBox = (selection, editor) => {
  const position = selection.getFirstPosition()
  if (!position) return false

  // Get all ancestors of the current position
  const ancestors = position.getAncestors()

  // Check if any ancestor is a simple box
  return ancestors.some(ancestor => {
    // Check if the element is a section with simple-box class
    if (ancestor.name === 'simpleBox') {
      const classes = editor.model.schema.getAttributeProperties(
        ancestor,
        'class',
      )
      return classes
    }
    return false
  })
}

const wrapStringInPTag = embedUrl => {
  const hasHtmlTags = /<[^>]*>/g.test(embedUrl)

  if (!hasHtmlTags) {
    return `<p>${embedUrl}</p>`
  }

  return embedUrl
}

export const handleEmbedInsert = async (
  embedUrl,
  position,
  modalData,
  editor,
  writer,
  dropAreaWide,
  doubleClick,
) => {
  let url

  const embedServices = [
    'canva',
    'synthesia',
    'googleServices',
    'webLink',
    'calendly',
    'scribe',
    'soundCloud',
    'spotify',
    'loom',
    'airtable',
    'h5p',
    'youtube',
  ]

  if (modalData.value === 'vimeo') {
    url = getVimeoEmbedUrl(embedUrl)
  } else if (modalData.value === 'html') {
    editor.editing.view.focus()

    editor.model.change(writer => {
      const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
      const simpleBox = writer.createElement('simpleBox')

      const htmlEmbed = writer.createElement('rawHtml', {
        value: wrapStringInPTag(embedUrl),
      })

      editor.model.insertContent(simpleBoxWrapper, position)

      writer.append(simpleBox, simpleBoxWrapper)
      writer.append(htmlEmbed, simpleBox)
      if (dropAreaWide !== undefined && dropAreaWide !== null) {
        writer.remove(dropAreaWide)
      }
    })

    const root = window.editor.model.document.getRoot()
    // Remove all existing drag areas first
    const dragAreas = Array.from(root.getChildren()).filter(
      child => child.name === 'dropAreaNarrow',
    )
    dragAreas.forEach(dragArea => {
      window.editor.model.change(writer => {
        writer.remove(dragArea)
      })
    })
  } else if (embedServices.includes(modalData.value)) {
    try {
      const response = await axios.post(URL.EMBED, {
        url: embedUrl,
      })
      // Check if the response contains the expected data
      if (response.status === 200) {
        editor.editing.view.focus()
        if (response.data.data.html !== null) {
          editor.model.change(writer => {
            const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
            const simpleBox = writer.createElement('simpleBox')

            const htmlEmbed = writer.createElement('rawHtml', {
              value: response.data.data.html,
            })

            editor.model.insertContent(simpleBoxWrapper, position)

            writer.append(simpleBox, simpleBoxWrapper)
            writer.append(htmlEmbed, simpleBox)
            if (dropAreaWide !== undefined && dropAreaWide !== null) {
              writer.remove(dropAreaWide)
            }
          })
        } else {
          editor.model.change(writer => {
            let sampleHtml
            sampleHtml = `
                  <div class="simple-box-wrapper"> 
                    <div class="simple-box">
                      <div class="column">
                        <p>
                          <iframe class="iframe-player" src=${embedUrl}></iframe>
                        </p>
                      </div>
                    </div>
                  </div>`

            const viewFragment = editor.data.processor.toView(sampleHtml)
            const modelFragment = editor.data.toModel(viewFragment)
            // Insert the model fragment into the editor at the current selection
            editor.model.insertContent(modelFragment, position)
            if (dropAreaWide !== undefined && dropAreaWide !== null) {
              writer.remove(dropAreaWide)
            }
          })
        }
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Embed generation error:', error)
      // Optionally, you could add user-friendly error handling
      // For example, showing a toast or notification
    }
  }

  let sampleHtml

  if (modalData.value === 'vimeo') {
    if (url !== null) {
      editor.model.change(writer => {
        sampleHtml = `
              <div class="simple-box-wrapper"> 
                <div class="simple-box">
                  <div class="column">
                    <p>
                      <iframe class="iframe-player" src=${url}></iframe>
                    </p>
                  </div>
                </div>
              </div>`

        const viewFragment = editor.data.processor.toView(sampleHtml)
        const modelFragment = editor.data.toModel(viewFragment)
        // Insert the model fragment into the editor at the current selection
        editor.model.insertContent(modelFragment, position)
        if (dropAreaWide !== undefined && dropAreaWide !== null) {
          writer.remove(dropAreaWide)
        }
      })
    } else {
      editor.execute('undo')
    }
  }
}
const aiInstructionConfirmSelection = async (
  selectedData,
  sourceText,
  position,
  editor,
  dispatch,
  fontFamily,
  language,
) => {
  // Initial progress value
  let progress = 0

  // Show initial loading modal
  const showLoadingModal = (currentProgress, isResponse = false) => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.INFO,
          title: ``,
          buttons: [],

          hideCloseButton: true,
          component: (
            <AiLoading
              progress={currentProgress}
              responseReceived={isResponse}
            />
          ),
          callback: () => {},
        }),
      ),
    )
  }

  // Show initial loading state
  showLoadingModal(progress)

  try {
    // Make API request
    const response = await axios.post(
      'https://claude-ghwy.onrender.com/api/createInteraction',
      {
        selected_data: selectedData,
        source_text: sourceText,
        font: fontFamily,
        language: language,
      },
    )
    const root = editor.model.document.getRoot()

    // Get all dropAreaWide elements in the root
    const dropAreaWides = Array.from(root.getChildren()).filter(
      child => child.name === 'dropAreaWide',
    )
    if (dropAreaWides.length !== 0) {
      editor.model.change(writer => {
        // Remove each dropAreaWide safely
        dropAreaWides.forEach(dropAreaWide => {
          // Create a range on the element to remove it
          const range = writer.createRangeOn(dropAreaWide)

          // Store positions before removing
          const position = range.start

          // Remove the element
          writer.remove(dropAreaWide)

          // Now you can use the position to insert content if needed
          // For example: writer.insertText('Replacement content', position);
        })
      })
    }

    // Hide loading when data is received
    dispatch(messageBoxHideAction())

    if (response.data) {
      const htmlContent = response.data
      const processedHtml = htmlContent.replace(/"/g, "'")

      // Generate a random instruction code for uniqueness
      const randomInstructionCode =
        'math_eq_' + Math.random().toString(36).substring(2, 10)

      // Modify the HTML to include our script with the random instruction code
      const modifiedHtml = htmlContent.replace(
        '</body>',
        `
        <!-- Script for responsive iframe height -->
        <script>
          // Adjust iframe height when the content changes
          function adjustIframeHeight() {
            const height = document.body.scrollHeight;
            const interactionCode = '${randomInstructionCode}';
            
            // Send message to parent window
            window.parent.postMessage(
              {
                interactionCode: interactionCode,
                type: 'SET_INSTRUCTION_HEIGHT',
                value: height,
              },
              '*'
            );
          }
          
          // Run on page load
          window.addEventListener('load', adjustIframeHeight);
          
          // Run on window resize
          window.addEventListener('resize', adjustIframeHeight);
          
          // Also run periodically to catch any dynamic content changes
          setInterval(adjustIframeHeight, 1000);
        </script>
      </body>`,
      )

      const calculateHeight = html => {
        const tempDiv = document.createElement('div')

        tempDiv.style.position = 'absolute'
        tempDiv.style.visibility = 'hidden'
        tempDiv.style.width = '100%'
        tempDiv.style.maxWidth = '800px'
        tempDiv.style.overflow = 'auto'
        tempDiv.style.fontSize = '16px'
        tempDiv.style.lineHeight = '1.5'

        tempDiv.innerHTML = html

        const images = tempDiv.getElementsByTagName('img')
        let imageLoadPromises = []

        for (let i = 0; i < images.length; i++) {
          if (!images[i].complete) {
            const promise = new Promise(resolve => {
              images[i].onload = resolve
              images[i].onerror = resolve
            })
            imageLoadPromises.push(promise)
          }
        }

        document.body.appendChild(tempDiv)

        return Promise.all(imageLoadPromises).then(() => {
          const scrollH = tempDiv.scrollHeight
          const offsetH = tempDiv.offsetHeight
          const clientH = tempDiv.clientHeight

          const contentHeight = Math.max(scrollH, offsetH, clientH)

          document.body.removeChild(tempDiv)

          return Math.max(500, contentHeight + 150) + 'px'
        })
      }

      calculateHeight(processedHtml).then(iframeHeight => {
        editor.editing.view.focus()
        editor.model.change(writer => {
          const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
          const simpleBox = writer.createElement('simpleBox')

          const iframe = document.createElement('iframe')

          // Set the srcdoc attribute with the modified HTML content
          iframe.srcdoc = modifiedHtml

          // Set the inline styles
          iframe.style.width = '100%'
          iframe.style.height = iframeHeight
          iframe.style.border = 'none'

          // Set data attribute with the instruction code for identification
          iframe.dataset.interactionCode = randomInstructionCode

          const htmlEmbed = writer.createElement('rawHtml', {
            value: iframe.outerHTML, // Convert the iframe element to HTML string
          })

          editor.model.insertContent(simpleBoxWrapper, position)
          writer.append(simpleBox, simpleBoxWrapper)
          writer.append(htmlEmbed, simpleBox)
        })
      })
    }
  } catch (error) {
    // Show error state or hide the modal
    dispatch(messageBoxHideAction())

    dispatch(
      snackbarShowAction(
        new SnackbarMessage(`error_${Date.now()}`, 'error', [
          'A technical issue has occurred. Please try again.',
        ]),
      ),
    )
  }
}

export const handleAddEmbed = (
  modalData,
  position,
  editor,
  dispatch,
  Embed,
  writer,
  dropAreaWide,
  doubleClick,
) => {
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: ``,
        buttons: [],
        component: (
          <Embed
            modalData={modalData}
            onEmbed={url => {
              handleEmbedInsert(
                url,
                position,
                modalData,
                editor,
                writer,
                dropAreaWide,
                doubleClick,
              )
              dispatch(messageBoxHideAction())
            }}
          />
        ),
        callback: () => {
          editor.execute('undo')
        },
      }),
    ),
  )
}
export const removeIframesCompletely = data => {
  // Get content from the editor
  let content = data

  // Method 1: Using regular expression to remove iframe tags and their content
  content = content.replace(/<iframe\b[^>]*>[\s\S]*?<\/iframe>/gi, '')

  // Method 2: Using DOM manipulation (more reliable for complex HTML)
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = content

  // Find and remove all iframes
  const iframes = tempDiv.querySelectorAll('iframe')
  iframes.forEach(iframe => {
    iframe.parentNode.removeChild(iframe)
  })

  // Get the cleaned content
  const cleanedContent = tempDiv.innerHTML

  // Return the cleaned content (you can use either method's result)
  // You can also use editor.setData(cleanedContent) to update the editor
  return cleanedContent
}
export const handleAddInterActive = (
  modalData,
  position,
  editor,
  dispatch,
  Embed,
  writer,
  dropAreaWide,
  doubleClick,
  fontFamily,
  language,
) => {
  dispatch(processStartAction())
  dispatch({
    type: AI_INSTRUCTION,
    payload: {
      starterText: removeIframesCompletely(editor.getData()),
      language: language,
      callback: responseData => {
        try {
          dispatch(processStartEnd())

          const jsonStart = responseData.indexOf('{')
          const jsonEnd = responseData.lastIndexOf('}') + 1
          const jsonString = responseData.substring(jsonStart, jsonEnd)
          const data = JSON.parse(jsonString)
          JSON.parse(jsonString)
          const handleConfirmWithSelection = (selectedData, sourceText) => {
            aiInstructionConfirmSelection(
              selectedData,
              sourceText,
              position,
              editor,
              dispatch,
              fontFamily,
              language,
            )
          }
          const handleCancel = () => {
            dispatch(messageBoxHideAction())
          }

          dispatch(
            messageBoxShowAction(
              MessageBoxContent({
                type: MessageBoxType.WARNING,
                title: `
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                  "
                >
                <Typography
                  style="
                    color: var(--mcg-dark, #002E47);
                    font-family: Inter;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%; 
                  "
                >
                  Interactive Activity
                </Typography>
              </div>`,
                draggable: false,
                buttons: [],
                component: (
                  <Instruction
                    data={data}
                    sourceText={removeIframesCompletely(editor.getData())}
                    aiInstructionConfirmSelection={handleConfirmWithSelection}
                    handleCancel={handleCancel}
                  />
                ),
                callback: () => {
                  editor.execute('undo')
                },
              }),
            ),
          )
        } catch (error) {
          dispatch(
            snackbarShowAction(
              new SnackbarMessage(`error_${Date.now()}`, 'error', [
                'A technical issue has occurred. Please try again.',
              ]),
            ),
          )
        }
      },
    },
  })
}

export const handleEditorReady = (editorRef, onDropClose, dispatch, Embed) => {
  return editor => {
    editorRef.current = editor

    window.editor = editor
    editor.conversion.for('upcast').add(dispatcher => {
      dispatcher.on('element:a', (evt, data, conversionApi) => {
        const viewLink = data.viewItem
        const modelRange = data.modelRange

        const isButton =
          viewLink.hasClass('simple-button') ||
          viewLink.findAncestor('div[class*="button-wrapper"]')

        if (isButton) {
          evt.stop()
          return
        }
        if (viewLink.hasAttribute('href')) {
          const href = viewLink.getAttribute('href')
          const writer = conversionApi.writer

          const linkText = Array.from(viewLink.getChildren())
            .map(child => child.data || '')
            .join('')

          writer.setAttribute('linkHref', href, modelRange)
          writer.setAttribute('linkText', linkText, modelRange)
        }
      })
    })

    editor.conversion.for('editingDowncast').add(dispatcher => {
      dispatcher.on('attribute:linkHref', (evt, data, conversionApi) => {
        const { item } = data

        if (isInButton(item)) {
          evt.stop()
          return
        }
      })
    })

    editor.conversion.for('dataDowncast').add(dispatcher => {
      dispatcher.on('attribute:linkHref', (evt, data, conversionApi) => {
        const { item, attributeNewValue } = data

        if (isInButton(item)) {
          evt.stop()
          return
        }

        if (attributeNewValue) {
          const viewWriter = conversionApi.writer
          const originalText = item.getAttribute('linkText') || item.data

          const linkElement = viewWriter.createContainerElement('a', {
            href: attributeNewValue,
          })

          viewWriter.insert(
            viewWriter.createPositionAt(linkElement, 0),
            viewWriter.createText(originalText),
          )
          conversionApi.consumable.consume(item, evt.name)
        }
      })
    })
    function isInButton(item) {
      let parent = item.parent
      while (parent) {
        if (
          parent.name === 'simpleButton' ||
          parent.name === 'buttonWrapper' ||
          parent.name === 'simpleIcon'
        ) {
          return true
        }
        parent = parent.parent
      }
      return false
    }

    editor.model.schema.extend('$text', {
      allowAttributes: ['linkHref', 'linkText'],
    })
    const cleanupLinks = () => {
      const model = editor.model
      const root = model.document.getRoot()

      model.change(writer => {
        const range = writer.createRangeIn(root)

        for (const item of range.getItems()) {
          if (item.hasAttribute('linkHref')) {
            if (isInButton(item)) {
              writer.removeAttribute('linkHref', item)
              writer.removeAttribute('linkText', item)
            }
          }
        }
      })
    }

    cleanupLinks()
    editor.model.document.on('change:data', () => {
      cleanupLinks()
    })

    document.addEventListener('DOMContentLoaded', function () {
      const images = document.querySelectorAll('.column img')

      images.forEach(img => {
        img.setAttribute('draggable', 'false')

        img.addEventListener('dragstart', function (e) {
          e.preventDefault()
        })

        img.addEventListener('mousedown', function (e) {
          e.preventDefault()
        })
      })
    })
    document.addEventListener('DOMContentLoaded', function () {
      const outline = document.querySelectorAll('.editor-outline')

      outline.forEach(outline => {
        outline.setAttribute('draggable', 'false')

        outline.addEventListener('dragstart', function (e) {
          e.preventDefault()
        })

        outline.addEventListener('mousedown', function (e) {
          e.preventDefault()
        })
      })
    })

    const codeBlockPlugin = editor.plugins.get('CodeBlock')
    if (codeBlockPlugin) {
      codeBlockPlugin.clearForceDisabled()
    }
    // Add schema rules to allow links in paragraphs
    editor.model.schema.extend('$text', {
      allowAttributes: ['linkHref', 'linkType'],
    })
    editor.editing.view.document.on('delete', (evt, data) => {
      const selection = editor.model.document.selection
      const firstPosition = selection.getFirstPosition()

      // Handle both image and video wrappers
      const isMediaWrapper =
        firstPosition.parent.is('element', 'imageWrapper') ||
        firstPosition.parent.is('element', 'imageWrapperAspectRatio') ||
        firstPosition.parent.is('element', 'videoWrapper')

      if (isMediaWrapper) {
        editor.model.change(writer => {
          // Get the parent element (wrapper)
          const wrapper = firstPosition.parent

          // Get the position before the wrapper
          const positionBefore = writer.createPositionBefore(wrapper)

          // Remove the wrapper
          writer.remove(wrapper)

          // Set the selection to the position before where the wrapper was
          writer.setSelection(positionBefore)
        })

        // Prevent default deletion behavior
        data.preventDefault()
        evt.stop()
      }
    })

    editor.editing.view.document.on('drag', event => {
      event.preventDefault()
    })
    document.addEventListener('drag', event => {
      // const menu = document.getElementById('editor-drag-drop-menu')
      //menu.style.visibility = 'hidden'
      event.preventDefault()
    })
    document.addEventListener('drop', event => {
      event.preventDefault()
      //const menu = document.getElementById('editor-drag-drop-menu')
      //menu.style.visibility = 'visible'
    })

    const addClickListenerToEmbeds = editor => {
      const elements = document.querySelectorAll(
        '.ck-widget.raw-html-embed.ck-widget_with-selection-handle',
      )

      elements.forEach(element => {
        element.addEventListener('click', function (e) {
          const rect = this.getBoundingClientRect()
          const x = e.clientX - rect.left

          if (x >= rect.width - 22) {
            editor.model.change(writer => {
              const selection = editor.model.document.selection
              const rawHtml = selection.getSelectedElement()

              if (rawHtml && rawHtml.name === 'rawHtml') {
                writer.remove(rawHtml)
              }
            })
          }
        })
      })
    }

    // Create MutationObserver to watch for new elements
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          addClickListenerToEmbeds(editor)
        }
      })
    })

    // Start observing with configuration
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    // Initial setup
    addClickListenerToEmbeds(editor)

    editor.editing.view.document.on('paste', (evt, data) => {
      // Get the data from the paste event
      const htmlContent = data.dataTransfer.getData('text/html')

      if (htmlContent) {
        // Create a temporary div to hold the content
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlContent

        // Remove all style attributes from all elements
        const elements = tempDiv.getElementsByTagName('*')
        for (let i = 0; i < elements.length; i++) {
          elements[i].removeAttribute('style')
          elements[i].removeAttribute('class')
        }

        // Get the cleaned content
        const cleanedContent = tempDiv.innerHTML

        // Prevent the default paste behavior
        evt.stop()

        // Insert the cleaned content
        const viewFragment = editor.data.processor.toView(cleanedContent)
        const modelFragment = editor.data.toModel(viewFragment)
        editor.model.insertContent(modelFragment)
      }
    })

    editor.editing.view.document.on('drop', (event, data) => {
      const menu = document.getElementById('editor-drag-drop-menu')
      menu.style.visibility = 'visible'
      removeDropAreaNarrow(editor)

      if (data && data.domEvent) {
        const view = editor.editing.view
        const domEvent = data.domEvent

        domEvent.preventDefault()

        const domTarget = domEvent.target
        const viewPosition = view.domConverter.domPositionToView(domTarget, 0)

        if (viewPosition) {
          editor.editing.mapper.toModelPosition(viewPosition)
        } else {
          console.warn('Failed to determine view position.')
        }

        const dataTransfer = domEvent.dataTransfer
        if (dataTransfer) {
          dataTransfer.getData('text/html')

          onDropClose()

          if (dataTransfer.getData('boxData') === 'embed') {
            handleAddEmbed(
              JSON.parse(dataTransfer.getData('dragDropData')),
              editor.model.document.selection,
              editor,
              dispatch,
              Embed,
            )
          } else if (
            dataTransfer.getData('boxData') === 'actions' &&
            JSON.parse(dataTransfer.getData('dragDropData')).value ===
              'interactiveActivity'
          ) {
            const fontFamily = dataTransfer.getData('font')
            const language = dataTransfer.getData('language')
            handleAddInterActive(
              JSON.parse(dataTransfer.getData('dragDropData')),
              editor.model.document.selection,
              editor,
              dispatch,
              Embed,
              null,
              null,
              false,
              fontFamily,
              language,
            )
          } else {
            if (dataTransfer.getData('element')) {
              const elementObj = dataTransfer.getData('element')
              editor.model.change(writer => {
                const newElement = createNestedElements(
                  JSON.parse(elementObj),
                  writer,
                )

                editor.model.insertContent(
                  newElement,
                  editor.model.document.selection,
                )
                // Helper function to create nested elements recursively
              })
            }
          }
        }
      } else {
        console.error('Drop event data is missing domEvent or is undefined.')
      }
    })
  }
}
const createNestedElements = (elementConfig, writer) => {
  const element = writer.createElement(
    elementConfig.name,
    elementConfig.attributes || {},
  )

  // Eğer bu simpleButton ise, text ve icon ekle
  if (elementConfig.name === 'simpleButton') {
    const text = writer.createText(elementConfig.attributes.text || 'Button')
    const simpleIcon = writer.createElement('simpleIcon', {
      icon: elementConfig.attributes.icon || '',
    })

    writer.append(simpleIcon, element)
    writer.append(text, element)
  }
  // Normal children ekleme işlemi
  else if (elementConfig.children && elementConfig.children.length > 0) {
    elementConfig.children.forEach(childConfig => {
      const childElement = createNestedElements(childConfig, writer)
      writer.append(childElement, element)
    })
  }

  return element
}

// Font Size Calculate

export const calculateFontSize = (baseSize, sizeModifier = null) => {
  const sizeMap = {
    XS: -4,
    S: -2,
    M: 0,
    L: 2,
    XL: 4,
  }

  return baseSize + (sizeModifier ? sizeMap[sizeModifier] : 0)
}

export const replaceContentById = (id, newHtml) => {
  const currentData = window.editor.getData()
  const parser = new DOMParser()
  const doc = parser.parseFromString(currentData, 'text/html')

  const targetElement = doc.querySelector(`[id="${id}"]`)
  if (!targetElement) {
    return false
  }
  targetElement.innerHTML = newHtml

  const updatedContent = doc.body.innerHTML

  window.editor.setData(updatedContent)

  return true
}
